__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "discovery-host-fe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("antd", "5.29.3", () => (Promise.all([__webpack_require__.e(239), __webpack_require__.e(96), __webpack_require__.e(120), __webpack_require__.e(278)]).then(() => (() => (__webpack_require__(48527))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(967), __webpack_require__.e(120)]).then(() => (() => (__webpack_require__(8143))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(967), __webpack_require__.e(96), __webpack_require__.e(120), __webpack_require__.e(278), __webpack_require__.e(733)]).then(() => (() => (__webpack_require__(95980))))));
			register("react-router", "6.30.6", () => (Promise.all([__webpack_require__.e(967), __webpack_require__.e(96), __webpack_require__.e(120)]).then(() => (() => (__webpack_require__(36612))))));
			register("react", "18.3.1", () => (__webpack_require__.e(967).then(() => (() => (__webpack_require__(30758))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};